import React from 'react';
import { classNames } from '../common/utils/utils';

interface ToggleProps {
    value: boolean;
    onChange: (value: boolean) => void;
    disabledText: string;
    enabledText: string;
    label?: string;
    error?: string;
    id?: string;
}

const Toggle = ({ value, onChange, label, disabledText, enabledText, id }: ToggleProps) => {

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        return onChange(e.target.value === 'true' ? true : false)
    }

    return (
        <div className="flex flex-col items-start gap-1">
            <label className="h-full text-normal font-roboto text-gray-700 pb-1">{label}</label>
            <div className="flex flex-row gap-4 items-center">
                <div className="inline-flex  items-center p-1 rounded-md cursor-pointer dark:text-gray-800">
                    <input id={`${id}_false`} onChange={handleChange} className="peer/left hidden" type="radio" name="status" value={"false"} checked={!value} />
                    <label htmlFor={`${id}_false`} className={classNames("px-6 py-4  select-none flex justify-center rounded-l-md bg-cool-gray-100 peer-checked/left:bg-sky-500 ", !value ? 'text-white' : ' text-gray-700 ')}>{disabledText}</label>

                    <input id={`${id}_true`} onChange={handleChange} className="peer/right hidden" type="radio" name="status" value={"true"} checked={value} />
                    <label htmlFor={`${id}_true`} className={classNames("px-6 py-4  select-none flex justify-center rounded-r-md bg-cool-gray-100 peer-checked/right:bg-sky-500", value ? 'text-white' : ' text-gray-700 ')}>{enabledText}</label>
                </div>
            </div>
        </div>
    );
};

export default Toggle;
